export const ADMISSION_PRELUDE_ROUTE = "/admission/prelude";
